export default theme => ({
    offerGrid: {
        position: 'relative',
        marginBottom: 36,
        [theme.breakpoints.up('md')]: {
            // margin: '100px 0',
        }
    },
})